import type { IconSvgObject } from './types';

const PathfinderUniteIcon: IconSvgObject = [
  ["path", { d: "M4 2H13C14.1046 2 15 2.89543 15 4V9H20C21.1046 9 22 9.89543 22 11V20C22 21.1046 21.1046 22 20 22H11C9.89543 22 9 21.1046 9 20V15H4C2.89543 15 2 14.1046 2 13V4C2 2.89543 2.89543 2 4 2Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default PathfinderUniteIcon;
